var map = {
	"./1.png": 1451,
	"./15.png": 4414,
	"./16.png": 1141,
	"./2.png": 160,
	"./Accessibility.png": 3234,
	"./ChatAI.png": 9200,
	"./Dashboard.png": 3406,
	"./GenerateAI.png": 991,
	"./GradientCraft.png": 6012,
	"./Library.png": 6671,
	"./PaletteStudio.png": 4173,
	"./SkyStudio.png": 7395,
	"./Subscription.png": 9427,
	"./TextureMaker.png": 5331,
	"./TokenStudio.png": 8015,
	"./UIPlaygroud.png": 5395,
	"./fundo.png": 9174,
	"./logo.png": 3153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7889;